import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'
import { VehicleIncident } from '@@partner:types:app'
import { CRUD_Variables, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { useCallback } from 'react'



export type AllVehicleIncidentsQuery = {
  allVehicleIncidents: {
    edges: VehicleIncident[]
    pageInfo: PageInfo
  }
}

export const GQL_QUERY_ALL_VEHICLE_INCIDENTS = gql`
  query AllVehicleIncidents(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allVehicleIncidents(
      filter: $filter
      pager: $pager
      sort: $sort
    ) {
      edges {
        id
        created_at
        updated_at
        incident_type
        description
        occurred_at
        vehicle_id
        courier_workshift_id
        courierWorkShift {
          id
          plannedStartAt
          plannedFinishAt
          plannedStartAt
          plannedFinishAt
          status
        }
        courier_id
        courier {
          id
          fullName
          phone
        }
        files {
          url
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`


export const useFetchAllVehicleIncidents = (variables: CRUD_Variables) => {
  const { data, loading, error, fetchMore } = useQuery<AllVehicleIncidentsQuery, CRUD_Variables>(GQL_QUERY_ALL_VEHICLE_INCIDENTS, {
    variables
  })

  const vehicleIncidents = data?.allVehicleIncidents.edges || []

  const updaterFunction = useCallback((cached: AllVehicleIncidentsQuery, fetched: AllVehicleIncidentsQuery) => {
    const prev = cached?.allVehicleIncidents?.edges ?? []
    const curr = fetched?.allVehicleIncidents?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        allVehicleIncidents: {
          ...fetched.allVehicleIncidents,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage, currentPage } = useFetchMorePagination({
    loading,
    page: data?.allVehicleIncidents.pageInfo.page ?? 1,
    pageVariable: 'pager',
    usePager: false,
    fetchMore,
    updaterFunction,
  })

  return { 
    data, 
    loading, 
    error, 
    vehicleIncidents,
    fetchMore,
    fetchNextPage,
    hasMore: hasMore && (!data?.allVehicleIncidents.pageInfo.lastPage || data?.allVehicleIncidents.pageInfo.lastPage > currentPage),
  }
}